import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Services from "./components/Services";
import TexteLocal from "./components/TexteLocal";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Formulaire from "./components/Formulaire";
import Maillage from "./components/Maillage";
import CTAAppel from "./components/CTAAppel";

export default function HaguenauPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Réparation Volet Roulant Haguenau | Dépannage 24h Dépan'Volets"
        description="Réparation, motorisation et pose de volet roulant à Haguenau (Bas-Rhin). Toutes marques, intervention rapide, devis gratuit. 03 74 47 32 40."
        path="/haguenau"
        type="service"
        serviceType="Réparation de volet roulant"
        city="Haguenau"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Zones d'intervention", href: "/zones-d-intervention" }, { label: "Haguenau" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Zones d'intervention", href: "/zones-d-intervention" }, { label: "Haguenau" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Services />
        <TexteLocal />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Formulaire />
        <Maillage />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}